import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/employment_type.json";

export const useEmploymentTypes = () => useSourceFlowCollection(data);

export default useEmploymentTypes();
